import React from 'react';
import './ThankyouMessage.css'
import { Modal } from 'react-bootstrap';

const ThankyouMessage = (props) => {

    return (
        <div className='thankyou-page'>
            <img 
            className="thankyou-image"
            src={'../../../../images/thankyou-image.jpg'} alt="thankyou image" />
            <h4>Thank You</h4>
            <p>Your submission has been received.</p>
            {/*  We will be in touch and contact you soon ! */}
            <button type="button" onClick={props.close} className="close-button">Close</button>
        </div>
    );
};

export default ThankyouMessage;